import React from 'react';
import useOffer from '../../../../store/offer/useOffer';
import BoatOfferDetails from './BoatOfferDetails';
import VillasureOfferDetails from './VillasureOfferDetails';

const OfferDetailsPicker: React.FC = () => {
  const { offer } = useOffer();

  switch (offer.info.insurance_type) {
    case 'home':
      return <VillasureOfferDetails />;
    case 'boat':
      return <BoatOfferDetails />;
    default:
      return null;
  }
};

export default OfferDetailsPicker;
